export type DashboardWidthTier = 'phone' | 'narrow' | 'wide';

export const NARROW_COLUMN_CAP = 2;

export function widthTierOf(matchesSm: boolean, matchesLg: boolean): DashboardWidthTier {
  if (!matchesSm) return 'phone';
  return matchesLg ? 'wide' : 'narrow';
}

export function effectiveCardColumns(savedColumns: number, tier: DashboardWidthTier): number {
  if (tier === 'phone') return 1;
  if (tier === 'narrow') return Math.min(savedColumns, NARROW_COLUMN_CAP);
  return savedColumns;
}
